module.exports = __webpack_public_path__ + "assets/img/62fc-is.svg";